import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@src/environments/environment';
import { catchError, map, of } from 'rxjs';
import {
  GetNewslettersResponse,
  UpdateNewsletterCustomResponse,
  UpdateNewsletterRequest
} from '../models/newsletters-api.model';

@Injectable({
  providedIn: 'root'
})
export class NewslettersApi {
  readonly #http = inject(HttpClient);

  getNewsletters$() {
    return this.#http
      .get<GetNewslettersResponse>(`${environment.protocol}${environment.webApiUrl}/user/newsletter`)
      .pipe(catchError(() => of([] as GetNewslettersResponse)));
  }

  updateNewsletter$(updateNewsletterRequest: UpdateNewsletterRequest) {
    const { eventSeriesNo: eventSeriesNumber, value } = updateNewsletterRequest;

    const mapUpdateNewsletterRequestToCustomResponse = (
      receiveNewsletter: boolean
    ): UpdateNewsletterCustomResponse => ({
      eventSeriesNumber,
      receiveNewsletter
    });

    return this.#http
      .patch<UpdateNewsletterCustomResponse>(
        `${environment.protocol}${environment.webApiUrl}/user/newsletter`,
        updateNewsletterRequest
      )
      .pipe(
        map(() => mapUpdateNewsletterRequestToCustomResponse(value)),
        catchError(() => of(mapUpdateNewsletterRequestToCustomResponse(!value)))
      );
  }
}
